import { ReactNode, useEffect } from 'react';

// Ventana modal del rediseño. `abajo` = hoja que sube desde el borde inferior
// (elegir modificadores), si no, centrada (confirmaciones, formularios cortos).
export default function Dialogo({ titulo, children, onCerrar, abajo = false, ancho = 480 }: {
  titulo: string; children: ReactNode; onCerrar: () => void; abajo?: boolean; ancho?: number;
}) {
  useEffect(() => {
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') onCerrar(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onCerrar]);

  return (
    <div onClick={onCerrar} style={{
      position: 'fixed', inset: 0, zIndex: 50, background: 'rgba(20,16,12,.45)', display: 'flex',
      alignItems: abajo ? 'flex-end' : 'center', justifyContent: 'center', padding: abajo ? 0 : 16,
    }}>
      <div role="dialog" aria-modal="true" aria-label={titulo} onClick={e => e.stopPropagation()} style={{
        width: '100%', maxWidth: ancho, maxHeight: abajo ? '86vh' : '90vh', overflowY: 'auto',
        background: 'var(--surface)', color: 'var(--ink)', padding: 24,
        borderRadius: abajo ? '20px 20px 0 0' : 18, display: 'flex', flexDirection: 'column', gap: 16,
        boxShadow: '0 20px 50px rgba(0,0,0,.25)',
      }}>
        <div style={{ fontSize: 22, fontWeight: 700 }}>{titulo}</div>
        {children}
      </div>
    </div>
  );
}
